<template>
  <MAFieldWrapper
    v-slot="{ handleBlur }"
    :label="label"
    :value="modelValue"
    :disabled="disabled"
    :required="required"
    :readonly="readonly"
    :placeholder="placeholder"
    :rules="rules"
  >
    <component
      :is="SelectVariant"
      :id="props.id"
      v-model="internalValue"
      :options="props.options"
      :option-label="props.optionLabel"
      :option-value="props.optionValue"
      :placeholder="props.placeholder"
      :filter="props.filter"
      :editable="props.editable"
      option-disabled="disabled"
      :class="{ 'text-red-500': props.invalid }"
      :disabled="props.disabled"
      :show-clear="props.showClear"
      :loading="props.loading"
      class="grow"
      @blur="onBlur(handleBlur)"
    />
  </MAFieldWrapper>
</template>

<script setup lang="ts" generic="T extends string | number = string">
import Dropdown from "@/volt/Select.vue";
import SoftSelect from "@/volt/SoftSelect.vue";
import MAFieldWrapper from "../primevueComponents/MAFieldWrapper.vue";
import type { DropdownOption } from "@/types/formData";

const props = defineProps<{
  modelValue?: any;
  label?: string;
  rules?: Record<string, any>;
  options: DropdownOption<T>[];
  optionLabel: string | ((data: DropdownOption<T>) => string);
  optionValue: string | ((data: DropdownOption<T>) => string);
  placeholder?: string;
  filter?: boolean;
  editable?: boolean;
  invalid?: boolean;
  required?: boolean;
  disabled?: boolean;
  showClear?: boolean;
  readonly?: boolean;
  id?: string;
  loading?: boolean;
  variant?: "default" | "soft";
}>();

const SelectVariant = computed(() => {
  return props.variant === "soft" ? SoftSelect : Dropdown;
});

const emit = defineEmits(["update:modelValue", "blur"]);

const internalValue = useVModel(props, "modelValue", emit);
function onBlur(cb: () => void) {
  if (cb) cb();
  emit("blur");
}
</script>

<style scoped></style>
